/**
   * @ngdoc directive
   * @name adjust.common.directive:filterKpi
   * @scope
   * @restrict E
   *
   * @description
   * Template for the kpi field
   *
   */
function filterKpi() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./filter-kpi.html')
  };
}

export { filterKpi };
